import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { CtyButton } from '../button/CtyButton';

export function ClaimSubmitSuccessModal({
  isOpen,
  claimNumber,
  showClaimNumber,
  title = 'Claim Submitted',
  message = 'The claim has been submitted.',
  onClose,
  onStartNewClaim,
}: Readonly<{
  isOpen: boolean;
  claimNumber: string | null;
  showClaimNumber: boolean;
  title?: string;
  message?: string;
  onClose: () => void;
  onStartNewClaim: () => void;
}>) {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      placement="center"
      classNames={{ backdrop: 'bg-black/50' }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1 border-b border-default-200">
          <span className="text-base font-semibold text-foreground">{title}</span>
        </ModalHeader>
        <ModalBody className="py-6">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-50 dark:bg-green-500/10">
              <Icon icon="mdi:check-circle" width={36} className="text-green-600 dark:text-green-400" />
            </div>
            <p className="text-sm text-default-700">{message}</p>
            {showClaimNumber && claimNumber ? (
              <p className="text-sm font-semibold text-foreground">
                Claim Number: <span className="font-bold text-green-700 dark:text-green-400">{claimNumber}</span>
              </p>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter className="border-t border-default-200 gap-2">
          <CtyButton variant="bordered" className="font-semibold" onPress={onClose}>
            Close
          </CtyButton>
          <CtyButton color="primary" className="font-semibold" onPress={onStartNewClaim}>
            Start New Claim
          </CtyButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
